export const auth = {
	true: 'true',
	false: 'false',
};
